var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerPointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 102,
    viewBox: "0 0 99 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PPTX FIle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72.8705 1H23.76C22.4096 1 21.3149 2.09195 21.3149 3.43902V98.561C21.3149 99.9081 22.4096 101 23.76 101H94.6661C96.0165 101 97.1111 99.9081 97.1111 98.561V25.181C97.1111 24.5341 96.8535 23.9138 96.395 23.4563L74.5994 1.71439C74.1408 1.25695 73.519 1 72.8705 1Z",
    fill: "white",
    stroke: "#979593",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M72.5884 1V23.0701C72.5884 24.4244 73.6862 25.5223 75.0406 25.5223H97.1107",
    stroke: "#979593",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.5376 33.8026C76.5632 33.8026 84.6905 42.0725 84.6905 52.274H66.5376V33.8026Z",
    fill: "#F5BA9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M84.8533 54.5973C84.8533 66.8618 74.2666 76.6465 61.7581 75.2611C52.2506 74.208 44.565 66.5001 43.5149 56.965C42.1334 44.4202 51.8898 33.8026 64.1188 33.8026V54.5973H84.8533ZM87.2927 85.1778H32.4072C31.7337 85.1778 31.1875 85.7255 31.1875 86.401C31.1875 87.0766 31.7337 87.6243 32.4072 87.6243H87.2927C87.9662 87.6243 88.5123 87.0766 88.5123 86.401C88.5123 85.7255 87.9662 85.1778 87.2927 85.1778ZM87.2927 79.0617H32.4072C31.7337 79.0617 31.1875 79.6094 31.1875 80.285C31.1875 80.9605 31.7337 81.5082 32.4072 81.5082H87.2927C87.9662 81.5082 88.5123 80.9605 88.5123 80.285C88.5123 79.6094 87.9662 79.0617 87.2927 79.0617Z",
    fill: "#C8C6C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.48687 82.8472H44.4678C47.1588 82.8472 49.3404 80.6513 49.3404 77.9427V38.7071C49.3404 35.9985 47.1588 33.8026 44.4678 33.8026H5.48687C2.79585 33.8026 0.614258 35.9985 0.614258 38.7071V77.9427C0.614258 80.6513 2.79585 82.8472 5.48687 82.8472Z",
    fill: "#C43E1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.3216 43.6752C30.9379 43.6752 33.7083 44.4855 35.6293 46.1026C37.5514 47.7207 38.5126 50.0645 38.5126 53.1323C38.5126 55.1024 38.0368 56.8541 37.0867 58.3874C36.1366 59.9219 34.7846 61.1144 33.0324 61.9659C31.2801 62.8162 29.2487 63.2421 26.9405 63.2421H21.3809V74.2484H15.2642V43.6752H27.3216ZM21.3811 58.3503H26.2346C28.1268 58.3503 29.5559 57.9234 30.5234 57.072C31.4897 56.2194 31.9723 54.9747 31.9723 53.3377C31.9723 50.1576 30.1206 48.5669 26.4152 48.5669H21.3811V58.3503Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerPointIcon);
export default __webpack_public_path__ + "static/media/powerPointIcon.3ce78d322db9e0d4c2790edcb61448bf.svg";
export { ForwardRef as ReactComponent };